var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useMemo } from 'react';
import { mockListFeaturesArray, mockMainTitleText } from './data';
import InformationTitleColumn from './micros/InformationColumn/Index';
import ListFeaturesHoverColumn from './micros/ListFeaturesColumn/Index';
import './main.scss';
import { AngledContainer } from '../../components/angledContainer/AngledContainer';
var angles = {
    topLeftInit: 0,
    topLeftEnd: 10,
    topRightInit: 100,
    topRightEnd: 0,
    bottomRightInit: 100,
    bottomRightEnd: 100,
    bottomLeftInit: 0,
    bottomLeftEnd: 100,
};
var TwoColumnsHoverTextList = function (_a) {
    var data = _a.data, _b = _a.textColorHoverClassActive, textColorHoverClassActive = _b === void 0 ? 'text-white' : _b, _c = _a.textColorItemClassDefault, textColorItemClassDefault = _c === void 0 ? 'text-enblue-900' : _c;
    var _d = data.mainTitleText, mainTitleText = _d === void 0 ? mockMainTitleText : _d, _e = data.listFeaturesArray, listFeaturesArray = _e === void 0 ? mockListFeaturesArray : _e, _f = data.withAnimation, withAnimation = _f === void 0 ? false : _f;
    var _g = useState(null), activeContentInformation = _g[0], setActiveContentInformation = _g[1];
    var _h = useState(true), isFirstTimelineCompleted = _h[0], setIsFirstTimelineCompleted = _h[1];
    var isFunctionallityReady = useMemo(function () { return !withAnimation || isFirstTimelineCompleted; }, [isFirstTimelineCompleted, withAnimation]);
    var rightColumnRef = useRef(null);
    var leftTextColumnRef = useRef(null);
    var mainElementTriggerRef = useRef(null);
    var leftColumnRef = useRef(null);
    var handleActiveContentInformation = function (newStateValue) {
        if (isFunctionallityReady) {
            setActiveContentInformation(newStateValue);
        }
    };
    useEffect(function () {
        // if (withAnimation) {
        //   runAndCreateTimeline({
        //     rightColumnRef,
        //     mainElementTriggerRef,
        //     leftTextColumnRef,
        //     setIsFirstTimelineCompleted,
        //     setActivationFromMobile,
        //     leftColumnRef,
        //     setActiveContentInformation,
        //   });
        // }
    }, []);
    var customPolygon = "polygon(100% 0%, 0 100%, 100% 100%)";
    return (_jsxs("div", __assign({ className: "hover-text-list relative w-full snap-center", ref: mainElementTriggerRef }, { children: [_jsx(AngledContainer, { customPolygon: customPolygon, className: "w-full bg-enblue-500 hoverListTriangle" }, void 0),
            _jsxs("div", __assign({ className: "lg:flex w-full px-[24px] md:px-[92px] lg:px-20 bg-enblue-500 pb-[104px] info-container relative block" }, { children: [_jsx(InformationTitleColumn, { textTitleColorClass: "text-white", mainTitleText: mainTitleText, nativeLeftTitleRef: leftTextColumnRef, nativeLeftColumnRef: leftColumnRef, activeContentItem: activeContentInformation }, void 0),
                    _jsx(ListFeaturesHoverColumn, { textColorHoverClassActive: textColorHoverClassActive, textColorItemClassDefault: textColorItemClassDefault, nativeMainRef: rightColumnRef, activeContentInformation: activeContentInformation, listFeaturesArray: listFeaturesArray, setActiveContentInformation: handleActiveContentInformation }, void 0)] }), void 0)] }), void 0));
};
export default TwoColumnsHoverTextList;
